import {useEffect, useState} from 'react';

import {IDatalistChoiceProps} from './IDatalistChoiceProps';
import FieldErrorMessage from '../messages/FieldErrorMessage';
import Loader from '../../loader/Loader';
import GetChoices from '../../../../useCase/Datalist/GetChoices';
import FetchDatalistGateway from '../../../../gateway/Datalist/FetchDatalistGateway';
import {OptionsAttributesInterface} from '../../../../domain/Options/OptionsInterface';
import GetChoicePresentation from '../../../../useCase/Datalist/GetChoicePresentation';
import { useAppDispatch, useAppSelector } from '../../../../store/hook';
import FormGateway from '../../../../gateway/Form/FormGateway';
import SaveUseCase from '../../../../domain/Form/SaveUseCase';
import getElementsIdToRender from '../../../util/getElementsIdToRender';
import Element from '../../../../domain/Element/Element';
import { updateElementTimestamp } from '../../../../store/element/elements';
import DatalistOptions from '../../../../domain/Options/DatalistOptions';

const DataListChoice = ({options, id, datalistId, defaultValue, classes, register, name, error, label, ...rest}: IDatalistChoiceProps) => {
  const [optionsFilter, setOptionsFilter] = useState<OptionsAttributesInterface[]|null>(null)
  const [isLoading, setLoading] = useState<boolean>(false)
  const [presentation, setPresentation] = useState<string>('');
  const [value, setValue] = useState<string|undefined>(defaultValue);
  const [show, setShow] = useState<boolean>(false);

  const formGateway = new FormGateway()
  const dispatch = useAppDispatch()

  const elementsWithConditionJSON = useAppSelector(state => state.elements.currentElementsWithCondition)
  const elementsWithCondition: Element[] = JSON.parse(elementsWithConditionJSON)
  const elementsWithCalculeJSON = useAppSelector(state => state.elements.currentElementsWithCalcule)
  const elementsWithCalcule: Element[] = JSON.parse(elementsWithCalculeJSON)
  const elementsWithReferenceJSON = useAppSelector(state => state.elements.currentElementsWithReference)
  const elementsWithReference: Element[] = JSON.parse(elementsWithReferenceJSON)

  useEffect(() => {
    if (defaultValue) {
      new GetChoicePresentation(new FetchDatalistGateway()).execute(datalistId, defaultValue).then(response => {
        setPresentation(response)
      })
    }
  }, [defaultValue])

  const handleChange = (e) => {
    const value = e.target.value
    setPresentation(value);
    setValue('');

    if (value.length < 3) {
      setOptionsFilter([])
      setShow(false)
      return false
    }

    setShow(true)
    setLoading(true)

    new GetChoices(new FetchDatalistGateway()).execute(datalistId, value).then((response: DatalistOptions | null) => {
    setLoading(false);

      const options = response?.options;
      if (options && Array.isArray(options)) {
        const uniqueArray = Array.from(
          new Map(options.map(item => [item.value.trim(), item])).values()
        );
        setOptionsFilter(uniqueArray);
      }
    });
  }

  const handleClickDatalist = (e) => {
    const value = e.target.dataset.value
    const label = e.target.dataset.label

    const datalistData = [];
    datalistData[id] = value;

    const saveUseCase = new SaveUseCase(formGateway)
    saveUseCase.execute(datalistData).then(
        () => {
            const elementsIdToRender: string[] = getElementsIdToRender(
                elementsWithCondition,
                id,
                elementsWithCalcule,
                elementsWithReference
            )
            elementsIdToRender.map(
                (elementIdToRender) => {
                    dispatch(updateElementTimestamp({'id': elementIdToRender}))
                }
            )
        }
    )

    setValue(value)
    setPresentation(label)
    setShow(false)
  }

  return (
    <div className={`${classes} u-relative  ${rest.readOnly && "readonly-element"}`}>
      <input className={'checkbox-toggle'} id={id} name={id} ref={register} value={value} disabled={rest.readOnly && true || false}/>

      <div className={`form-floating ${error ? 'error' : ''}`} title={rest.help}>
        <input className="form-control"
               type="text"
               id={name}
               name={name}
               placeholder={name}
               value={presentation}
               autoComplete="new-password"
               onChange={handleChange}
               disabled={rest.readOnly && true || false}
        />
        <label htmlFor={name}>{label}</label>
      </div>

      {(show &&
      <div className={`datalist-choice`}>
        {(optionsFilter && optionsFilter.length > 0 &&
          optionsFilter?.map(option => {
            return <div key={option.value} className="datalist-choice__item" data-value={option.value} data-label={option.label} onClick={handleClickDatalist}>{option.label}</div>
          })
        )}
        {(isLoading &&
          <Loader />
        )}
      </div>
      )}

      {error?.message && <FieldErrorMessage message={error.message} />}

    </div>

  )
};

export default DataListChoice;
